class KsLookBook extends HTMLElement {
  constructor() {
    super();
    this.points = Array.from(this.querySelectorAll('.ks-lookbook-point-list-item'));
    this.cleanupFunctions = [];
    this.activePoint = null;
    this.boundResize = this.repositionActiveTooltip.bind(this);
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.cleanupFunctions.forEach((cleanup) => cleanup());
    this.cleanupFunctions = [];
    window.removeEventListener('resize', this.boundResize);
    window.removeEventListener('scroll', this.boundResize, true);
  }

  init() {
    if (!this.points.length) return;

    this.points.forEach((point) => this.initializeTooltip(point));
    window.addEventListener('resize', this.boundResize, { passive: true });
    window.addEventListener('scroll', this.boundResize, true);
  }

  initializeTooltip(element) {
    const button = element.querySelector('button');
    const tooltip = element.querySelector('.ks-tooltip');
    if (!button || !tooltip) return;

    const enableHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    const showTooltip = () => {
      this.hideAllTooltips(element);
      button.classList.add('active');
      button.setAttribute('aria-expanded', 'true');
      tooltip.classList.remove('hiding');
      tooltip.classList.add('show');
      tooltip.setAttribute('aria-hidden', 'false');
      this.activePoint = element;
      this.positionTooltip(element);
    };

    const hideTooltip = () => {
      button.classList.remove('active');
      button.setAttribute('aria-expanded', 'false');
      tooltip.setAttribute('aria-hidden', 'true');
      tooltip.classList.add('hiding');
      tooltip.addEventListener(
        'animationend',
        () => {
          tooltip.classList.remove('hiding', 'show');
        },
        { once: true }
      );

      if (this.activePoint === element) {
        this.activePoint = null;
      }
    };

    const toggleTooltip = (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (tooltip.classList.contains('show')) {
        hideTooltip();
      } else {
        showTooltip();
      }
    };

    if (enableHover) {
      button.addEventListener('mouseenter', showTooltip);
      button.addEventListener('mouseleave', hideTooltip);
      tooltip.addEventListener('mouseenter', showTooltip);
      tooltip.addEventListener('mouseleave', hideTooltip);
    }

    button.addEventListener('focus', showTooltip);
    button.addEventListener('blur', hideTooltip);
    button.addEventListener('click', toggleTooltip);

    const handleClickOutside = (event) => {
      if (tooltip.classList.contains('show') && !element.contains(event.target)) {
        hideTooltip();
      }
    };

    document.addEventListener('click', handleClickOutside);

    this.cleanupFunctions.push(() => {
      if (enableHover) {
        button.removeEventListener('mouseenter', showTooltip);
        button.removeEventListener('mouseleave', hideTooltip);
        tooltip.removeEventListener('mouseenter', showTooltip);
        tooltip.removeEventListener('mouseleave', hideTooltip);
      }

      button.removeEventListener('focus', showTooltip);
      button.removeEventListener('blur', hideTooltip);
      button.removeEventListener('click', toggleTooltip);
      document.removeEventListener('click', handleClickOutside);
    });
  }

  hideAllTooltips(exceptElement = null) {
    this.points.forEach((point) => {
      if (point === exceptElement) return;

      const button = point.querySelector('button');
      const tooltip = point.querySelector('.ks-tooltip');
      if (!button || !tooltip) return;

      button.classList.remove('active');
      button.setAttribute('aria-expanded', 'false');
      tooltip.classList.remove('show', 'hiding');
      tooltip.setAttribute('aria-hidden', 'true');
    });
  }

  positionTooltip(element) {
    const button = element.querySelector('button');
    const tooltip = element.querySelector('.ks-tooltip');
    const imageWrapper = this.querySelector('.img-wrapper');
    if (!button || !tooltip || !imageWrapper) return;

    const buttonRect = button.getBoundingClientRect();
    const wrapperRect = imageWrapper.getBoundingClientRect();

    const tooltipWidth = tooltip.offsetWidth || 320;
    const tooltipHeight = tooltip.offsetHeight || 220;

    let left = buttonRect.left - wrapperRect.left + buttonRect.width / 2 - tooltipWidth / 2;
    let top = buttonRect.top - wrapperRect.top - tooltipHeight - 12;
    let placement = 'top';

    if (left < 8) {
      left = 8;
    }

    const maxLeft = Math.max(8, wrapperRect.width - tooltipWidth - 8);
    if (left > maxLeft) {
      left = maxLeft;
    }

    if (top < 8) {
      top = buttonRect.bottom - wrapperRect.top + 12;
      placement = 'bottom';
    }

    tooltip.dataset.placement = placement;
    tooltip.style.left = `${left}px`;
    tooltip.style.top = `${top}px`;
  }

  repositionActiveTooltip() {
    if (!this.activePoint) return;
    this.positionTooltip(this.activePoint);
  }
}

if (!customElements.get('ks-lookbook')) {
  customElements.define('ks-lookbook', KsLookBook);
}
